export default __webpack_public_path__ + "static/media/docs-image-01.b2fda8b3.png";